import { useState, useEffect } from "react";
import { useChartBar } from "../../hooks";

export default function Module_HealthAnalysisManagement_BarConsult({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  callMainAPI = () => null,
}) {
  const { renderBar } = useChartBar({
    setting: moduleData,
    isExportRawList: true,
  });
  const [chartData, setChartData] = useState({ raw: [], format: [] });

  useEffect(() => {
    let data = [
      {
        type: "1月",
        aa: 0,
        bb: 6,
      },
      {
        type: "2月",
        aa: 1,
        bb: 9,
      },
      {
        type: "3月",
        aa: 0,
        bb: 5,
      },
      {
        type: "4月",
        aa: 0,
        bb: 5,
      },
      {
        type: "5月",
        aa: 0,
        bb: 6,
      },
      {
        type: "6月",
        aa: 0,
        bb: 8,
      },
      {
        type: "7月",
        aa: 0,
        bb: 6,
      },
      {
        type: "8月",
        aa: 0,
        bb: 2,
      },
      {
        type: "9月",
        aa: 0,
        bb: 0,
      },
      {
        type: "10月",
        aa: 0,
        bb: 1,
      },
      {
        type: "11月",
        aa: 5,
        bb: 3,
      },
      {
        type: "12月",
        aa: 2,
        bb: 8,
      },
    ];

    setChartData({
      raw: data,
      format: data,
      export: null,
    });
  }, []);

  return (
    <>
      <div className="w-full overflow-auto">
        {renderBar({
          moduleTitle,
          options: {
            moduleData: {
              ...moduleData,
              // columns: [{ key: "uv" }, { key: "sv" }, { key: "pv" }],
            },
            chartData,
            callMainAPI,
          },
        })}
      </div>
    </>
  );
}
